<template>
  <b-modal
    v-model="show"
    :title="null"
    :header-close-content="null"
    centered
    modal-class="modal-konfirmasi-nonaktifkan"
    body-class="p-0"
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    @hidden="onHidden"
  >
    <div class="p-[32px]">
      <!-- Close Button -->
      <button
        type="button"
        class="absolute top-[16px] right-[16px] w-[32px] h-[32px] flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
        @click="onCancel"
      >
        <feather-icon
          icon="XIcon"
          size="20"
          class="text-[#666666]"
        />
      </button>

      <!-- Icon -->
      <div class="flex justify-center mb-[20px]">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="Warning"
          class="w-[88px] h-[88px]"
        >
      </div>

      <!-- Title -->
      <h3 class="text-[20px] font-semibold text-[#333333] text-center mb-[12px]">
        Nonaktifkan Kategori?
      </h3>

      <!-- Description -->
      <p class="text-[14px] text-[#626262] text-center mb-[24px] leading-relaxed">
        Kategori ini masih digunakan oleh <strong>{{ campaignCount }} campaign</strong> dan <strong>{{ creatorCount }} kreator</strong>. Data lama tetap menampilkan kategori ini, tapi kategori tidak akan muncul untuk campaign atau pendaftar baru. Lanjutkan?
      </p>

      <!-- Actions -->
      <div class="flex gap-[12px]">
        <b-button
          variant="outline-secondary"
          class="flex-1 !rounded-[8px] !border-[#E5E5E5] !text-[#333333] !font-medium"
          @click="onCancel"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="flex-1 !rounded-[8px] !bg-[#F95031] !border-[#F95031] !font-medium"
          @click="onConfirm"
        >
          Ya, Nonaktifkan
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalKonfirmasiNonaktifkan',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    categoryName: {
      type: String,
      default: '',
    },
    campaignCount: {
      type: Number,
      default: 0,
    },
    creatorCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.show = false
    },
    onCancel() {
      this.$emit('cancel')
      this.show = false
    },
    onHidden() {
      this.$emit('hidden')
    },
  },
}
</script>

<style>
.modal-konfirmasi-nonaktifkan .modal-content {
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
}

.modal-konfirmasi-nonaktifkan .modal-dialog {
  max-width: 480px !important;
}
</style>
